if (!customElements.get('cart-cross-sell')) {
  customElements.define(
    'cart-cross-sell',
    class CartCrossSell extends HTMLElement {
      connectedCallback() {
        if (this.dataset.state === 'loaded') return;
        if (!this.dataset.productId) {
          this.remove();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.load();
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.adoptedModals?.forEach((modal) => modal.remove());
        if (this.onResize) window.removeEventListener('resize', this.onResize);
      }

      adoptModals(modalIds = []) {
        this.querySelectorAll('quick-add-modal').forEach((modal) => document.body.appendChild(modal));
        this.adoptedModals = modalIds.map((id) => document.getElementById(id)).filter(Boolean);
      }

      setupSlider() {
        const grid = this.querySelector('[data-cross-sell-grid]');
        const inner = this.querySelector('.cart-cross-sell__inner');
        if (!grid || !inner) return;

        const makeButton = (direction) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `cross-sell-nav cross-sell-nav--${direction}`;
          button.setAttribute('aria-label', direction === 'prev' ? 'Anterior' : 'Siguiente');
          button.innerHTML =
            '<svg viewBox="0 0 8 12" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1.5 1.5 6 6l-4.5 4.5"/></svg>';
          button.hidden = true;
          button.addEventListener('click', () => {
            const item = grid.querySelector('.grid__item');
            const step = item ? item.offsetWidth + 12 : grid.clientWidth;
            grid.scrollBy({ left: direction === 'prev' ? -step : step, behavior: 'smooth' });
          });
          return button;
        };

        this.prevButton = makeButton('prev');
        this.nextButton = makeButton('next');
        inner.append(this.prevButton, this.nextButton);

        const update = () => {
          const max = grid.scrollWidth - grid.clientWidth;
          this.prevButton.hidden = grid.scrollLeft <= 4;
          this.nextButton.hidden = grid.scrollLeft >= max - 4;
        };
        grid.addEventListener('scroll', update, { passive: true });
        this.onResize = update;
        window.addEventListener('resize', this.onResize);
        update();
      }

      load() {
        const url = `${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.sectionId}`;
        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((text) => {
            const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('cart-cross-sell');
            if (!fresh || !fresh.querySelector('.grid__item')) {
              this.remove();
              return;
            }
            const modalIds = [...fresh.querySelectorAll('quick-add-modal[id]')].map((modal) =>
              modal.getAttribute('id')
            );
            this.adoptedModals?.forEach((modal) => modal.remove());
            this.innerHTML = fresh.innerHTML;
            this.dataset.state = 'loaded';
            this.adoptModals(modalIds);
            if (this.classList.contains('cart-cross-sell--drawer')) this.setupSlider();
          })
          .catch((error) => {
            console.error('[cart-cross-sell]', error);
            this.remove();
          });
      }
    }
  );
}
